import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { InvoiceEntity } from './invoice.entity';
import { PaymentLinkEntity } from './payment-link.entity';

/**
 * PD-16674 — the invoices an invoice or statement payment link covers.
 *
 * Captured when the link is issued so the link pays exactly what was sent:
 * an invoice raised after a statement went out is not swept into that
 * statement's link. The balance is NOT captured; every view and every payment
 * re-reads the live invoice, so a link always shows and charges what is owed
 * now, and stops once nothing it covers is owed.
 *
 * `sortOrder` keeps the order the invoices were listed in (oldest due first),
 * which is the order a partial statement payment is allocated in.
 *
 * Written once with its link and never changed, so it is not audited; the
 * link row carries the audit trail.
 */
@Index('IDX_payment_link_invoice_link', ['fkPaymentLinkId'])
@Index('IDX_payment_link_invoice_invoice', ['fkInvoiceId'])
@Entity('payment_link_invoice', {}, { auditable: false })
export class PaymentLinkInvoiceEntity extends BaseEntity {
	@Column('int', { name: 'fk_payment_link__id', unsigned: true })
	public fkPaymentLinkId!: number;

	@ManyToOne(() => PaymentLinkEntity, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_payment_link__id', referencedColumnName: 'id' }])
	public fkPaymentLink?: PaymentLinkEntity;

	@Column('int', { name: 'fk_invoice__id', unsigned: true })
	public fkInvoiceId!: number;

	@ManyToOne(() => InvoiceEntity, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: 'fk_invoice__id', referencedColumnName: 'id' }])
	public fkInvoice?: InvoiceEntity;

	@Column('int', { name: 'sortOrder', unsigned: true, default: 0 })
	public sortOrder!: number;
}
